import React, { useMemo } from "react";
import { Paragraph } from "../Paragraph";
import { TableBase, TableKpiProviders } from "../categoryChartQueryFns";
import { ReportingTable } from "../ReportingTable";
import styles from "./CategoryChart.module.scss";
import _ from "lodash";
import { OPENDATA_DATA_DOWNLOAD_LINK, PROVIDER_TITLE_CLASS } from "../misc";
import {
    // DownloadButtonForFiles,
    // DownloadButtonForFilesProps,
    DownloadExcelFileForCSVS,
    // DownloadExcelFileForCSVSDemo,
    DownloadExcelFileForCSVSProps
} from "../StdButton";
import { CategoryChart, LongText } from "../processors";
import { Column } from "react-table";

interface ReportingTableProvidersProps extends TableKpiProviders {
    categoryChart: CategoryChart;
}

const TableProvider: React.FC<{
    providerName?: JSX.Element | string;
    openDataDownload?: JSX.Element | string;
    vis: (TableBase & {
        header?: LongText;
        footer?: LongText;
    })[];
    // downloadProps: DownloadButtonForFilesProps;
    className?: string;
}> = ({
    vis,
    providerName,
    openDataDownload,
    // downloadProps,
    className = ""
}) => {
    return (
        <div className={`col-12 ${className ?? ""}`}>
            {/* <DownloadExcelFileForCSVSDemo /> */}
            {
                // display names if more than one providers are given
                providerName != null && (
                    <div className={`${styles.providerTitle} ${styles.left} ${PROVIDER_TITLE_CLASS}`}>
                        {providerName}
                    </div>
                )
            }

            {/* {downloadProps != null && (
                <div>
                    <DownloadButtonForFiles {...downloadProps} className={styles.downloadButton} />
                </div>
            )} */}

            {
                // display link underneath the download button for single provider case
                openDataDownload != null && <div>{openDataDownload}</div>
            }

            {vis.map((__vis, index) => {
                return (
                    <React.Fragment key={index}>
                        {__vis?.header != null && (
                            <Paragraph
                                title={""}
                                status={true}
                                nid={0}
                                text={__vis?.header}
                                className={`${styles.tableHeadline}`}
                            />
                        )}

                        {__vis?.data != null && (
                            <ReportingTable
                                columnClassNames={__vis?.data?.columnClassNames}
                                columns={__vis?.data?.columns}
                                data={__vis?.data?.data}
                                pageSize={__vis?.data?.pageSize}
                                rowClassNames={__vis?.data?.rowClassNames}
                                className={__vis?.data?.className}
                            />
                        )}

                        {__vis?.footer != null && <Paragraph title={""} status={true} nid={0} text={__vis?.footer} />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
export const ReportingTableProviders: React.FC<ReportingTableProvidersProps> = ({ title, footer, vis }) => {
    const nameBasedVis = useMemo(() => {
        return vis?.filter(d => d?.data?.isProviderBasedTable == null || d?.data?.isProviderBasedTable === true);
    }, [vis]);

    const nonProviderBasedVis = useMemo(() => {
        return vis?.filter(d => d?.data?.isProviderBasedTable === false);
    }, [vis]);

    const nameToTables = useMemo(() => {
        return _.groupBy(nameBasedVis, d => d?.waterProvider?.name);
    }, [nameBasedVis]);

    const names = useMemo(() => {
        return _.uniq(nameBasedVis?.map(d => d?.waterProvider?.name));
    }, [nameBasedVis]);

    // const providerNames = useMemo(() => {
    //     return _.uniq(vis?.map(d => d?.waterProvider?.name)).filter(d => d != null && d?.trim() !== "");
    // }, [vis]);

    // const { contextType: comparisonPageContext } = useProviderComparePageContext();
    // const { contextType: infoPageContext } = useProviderInfoPageContext();

    // const contextType: ContextType = useMemo(() => {
    //     return infoPageContext ?? comparisonPageContext;
    // }, [comparisonPageContext, infoPageContext]);

    // const nonProviderDownloadButtonProps: DownloadButtonForFilesProps = useMemo(() => {
    //     const downloadableVis = nonProviderBasedVis?.filter(d => d?.data?.enabledDownload === true);
    //     if (!downloadableVis?.length) return null;

    //     const fileName = downloadableVis?.find(d => d?.data?.downloadFileName != null)?.data?.downloadFileName;

    //     const _columns = _.flatten(downloadableVis.map(d => d?.data?.columns));
    //     const _rows = _.flatten(downloadableVis.map(d => d?.data?.data));
    //     if (!_rows?.length) return null;

    //     const columns = _.uniqBy(_columns, d => d.Header);

    //     return {
    //         files: [
    //             {
    //                 columns,
    //                 dataObjects: _rows,
    //                 // fileName: `${fileName}.csv`
    //                 fileName
    //             }
    //         ],
    //         // fileName,
    //         fileName,
    //         providerNames: ""
    //     };
    // }, [nonProviderBasedVis]);

    const nonProviderXlsxFiles: { downloadProps: DownloadExcelFileForCSVSProps } = useMemo(() => {
        const downloadableVis = nonProviderBasedVis?.filter(d => d?.data?.enabledDownload === true);
        if (!downloadableVis?.length) return null;

        const fileName = downloadableVis?.find(d => d?.data?.downloadFileName != null)?.data?.downloadFileName;

        const _columns = _.flatten(downloadableVis.map(d => d?.data?.columns));
        const _rows = _.flatten(downloadableVis.map(d => d?.data?.data));
        if (!_rows?.length) return null;

        const columns = _.uniqBy(_columns, d => d.Header);

        return {
            downloadProps: {
                buttonLabel: "Download this data",
                files: [
                    {
                        columns,
                        dataObjects: _rows,
                        // fileName: `${fileName}.csv`
                        fileName: "Provider-wide"
                    }
                ],
                // fileName,
                fileName,
                providerNames: ""
            }
        };
    }, [nonProviderBasedVis]);

    // const files: { providerName: string; downloadProps: DownloadButtonForFilesProps }[] = useMemo(() => {
    //     return _.keys(nameToTables).map(providerName => {
    //         const _vis = nameToTables?.[providerName];
    //         const downloadableVis = _vis?.filter(d => d?.data?.enabledDownload === true);
    //         if (!downloadableVis?.length)
    //             return {
    //                 providerName,
    //                 downloadProps: null
    //             };

    //         const providerWide = downloadableVis?.filter(d => d.type === "provider-wide");
    //         const schemeBreakdown = downloadableVis?.filter(d => d.type === "scheme-breakdown");

    //         const categoryNames = _.join(_.uniq(downloadableVis?.map(d => d?.categoryName)), " - ");

    //         const fileName = `${providerName} - ${categoryNames}`;

    //         const files = [providerWide, schemeBreakdown]
    //             .map(dataset => {
    //                 const _columns = _.flatten(dataset.map(d => d?.data?.columns));
    //                 const _rows = _.flatten(dataset.map(d => d?.data?.data));
    //                 if (!_rows?.length) return null;

    //                 const columns = _.uniqBy(_columns, d => d.Header);
    //                 const typeName =
    //                     _.uniq(dataset.map(d => d.type))?.[0] === "provider-wide"
    //                         ? "Provider-wide"
    //                         : "Scheme-breakdown";

    //                 const categoryName = _.uniq(dataset.map(d => d.categoryName))?.[0];

    //                 const fileName = `${typeName} - ${categoryName ?? ""}.csv`;

    //                 return {
    //                     columns,
    //                     dataObjects: _rows,
    //                     fileName
    //                 };
    //             })
    //             .filter(d => d != null);

    //         return {
    //             providerName,
    //             downloadProps: {
    //                 files,
    //                 providerNames: providerName,
    //                 fileName
    //             }
    //         };
    //     });
    // }, [nameToTables]);

    const xlsxFiles: { downloadProps: DownloadExcelFileForCSVSProps } = useMemo(() => {
        // get providerWide
        const providerWideColumns: Column<{}>[] = _.uniqBy(
            _.flattenDeep(
                _.entries(nameToTables).map(([, _vis]) => {
                    return _vis
                        ?.filter(d => d.type === "provider-wide")
                        ?.map(d => d?.data?.columns ?? ([] as Column<{}>[]));
                })
            ) as Column<{}>[],
            d => d.Header
        );

        const providerWideDataObjects: {}[] = _.flattenDeep(
            _.entries(nameToTables).map(([, _vis]) => {
                return _vis?.filter(d => d.type === "provider-wide")?.map(d => d?.data?.data ?? ([] as {}[]));
            })
        );

        const providerWideFileName: string = _.uniq(
            _.flattenDeep(
                _.entries(nameToTables).map(([, _vis]) => {
                    return _vis?.find(d => d.type === "provider-wide")?.data?.downloadFileName;
                })
            )
        )?.find(d => d != null && d.trim() !== "");

        const providerWideDownloadFile: {
            columns: Column<{}>[];
            dataObjects: {}[];
            fileName: string;
        } =
            providerWideFileName == null || !providerWideColumns?.length || !providerWideDataObjects?.length
                ? null
                : {
                      columns: providerWideColumns,
                      dataObjects: providerWideDataObjects,
                      fileName: "Provider-wide"
                  };

        const schemeBreakdownColumns: Column<{}>[] = _.uniqBy(
            _.flattenDeep(
                _.entries(nameToTables).map(([, _vis]) => {
                    return _vis
                        ?.filter(d => d.type === "scheme-breakdown")
                        ?.map(d => d?.data?.columns ?? ([] as Column<{}>[]));
                })
            ) as Column<{}>[],
            d => d.Header
        );

        const schemeBreakdownDataObjects: {}[] = _.flattenDeep(
            _.entries(nameToTables).map(([, _vis]) => {
                return _vis?.filter(d => d.type === "scheme-breakdown")?.map(d => d?.data?.data ?? ([] as {}[]));
            })
        );

        const schemeBreakdownFileName: string = _.uniq(
            _.flattenDeep(
                _.entries(nameToTables).map(([, _vis]) => {
                    return _vis?.find(d => d.type === "provider-wide")?.data?.downloadFileName;
                })
            )
        )?.find(d => d != null && d.trim() !== "");

        const schemeBreakdownDownloadFile: {
            columns: Column<{}>[];
            dataObjects: {}[];
            fileName: string;
        } =
            schemeBreakdownFileName == null || !schemeBreakdownColumns?.length || !schemeBreakdownDataObjects?.length
                ? null
                : {
                      columns: schemeBreakdownColumns,
                      dataObjects: schemeBreakdownDataObjects,
                      fileName: "Scheme-breakdown"
                  };

        const categoryNames = _.join(
            _.uniq(
                _.flattenDeep(
                    _.entries(nameToTables).map(([, _vis]) => {
                        return _vis?.map(d => d.categoryName);
                    })
                )
            )?.filter(d => d != null && d.trim() !== ""),
            " - "
        );

        const providerNames = _.join(
            _.uniq(_.keys(nameToTables))?.filter(d => d != null && d.trim() !== ""),
            " - "
        );

        const className = _.join(
            _.uniq(_.flattenDeep(_.values(nameToTables))?.map(vis => vis?.data?.className))?.filter(
                d => d != null && d.trim() !== ""
            ),
            " - "
        );

        const fileName =
            providerNames == null ||
            providerNames?.trim() === "" ||
            categoryNames == null ||
            categoryNames?.trim() === ""
                ? null
                : _.join([providerNames, categoryNames], " - ");

        const files = [providerWideDownloadFile, schemeBreakdownDownloadFile].filter(d => d != null);

        return {
            downloadProps:
                fileName == null || fileName?.trim() === "" || !files?.length
                    ? null
                    : {
                          fileName,
                          files,
                          // providerNames,
                          buttonLabel: "Download this data",
                          className: className ?? "",
                          disabled: false
                      }
        };
    }, [nameToTables]);

    // const nameToDownloadProps = useMemo(() => {
    //     return _.keyBy(files, d => d.providerName);
    // }, [files]);

    const shouldDisplayOpendataLink = useMemo(() => {
        return nonProviderXlsxFiles?.downloadProps != null || xlsxFiles?.downloadProps != null;
        // files?.find(d => d.downloadProps != null) != null;
    }, [xlsxFiles, nonProviderXlsxFiles]);

    const downloadLink =
        shouldDisplayOpendataLink === true ? (
            <div className={`${styles.linkToOpendata}`}>
                <a href={OPENDATA_DATA_DOWNLOAD_LINK} target={"_blank"} rel="noopener noreferrer">
                    View the full Queensland water and sewerage service provider key performance indicator data set
                </a>
                &nbsp;from the Queensland Open Data Portal.
            </div>
        ) : null;

    return (
        <div className="row">
            {title != null && <Paragraph title={""} status={true} nid={0} text={title} className="col-12" />}
            {
                // display link above all for multi provider case
                // names?.length > 1 && <div className="col-12">{downloadLink}</div>
                downloadLink != null && <div className="col-12">{downloadLink}</div>
            }

            {nonProviderXlsxFiles?.downloadProps != null && (
                <div className="col-12">
                    <DownloadExcelFileForCSVS {...nonProviderXlsxFiles?.downloadProps} />
                </div>
            )}

            {xlsxFiles?.downloadProps != null && (
                <div className="col-12">
                    <DownloadExcelFileForCSVS {...xlsxFiles?.downloadProps} />
                </div>
            )}

            {nonProviderBasedVis?.length > 0 && (
                <TableProvider
                    className={`${styles.tableProvider} table-provider`}
                    // downloadProps={nonProviderDownloadButtonProps}
                    vis={nonProviderBasedVis}
                    providerName={undefined}
                    // display link underneath the download button for single provider case
                    // openDataDownload={names?.length > 0 ? null : downloadLink}
                    openDataDownload={undefined}
                />
            )}

            {names?.map((name, nameIndex) => {
                const _vis = nameToTables[name];

                if (!_vis?.length) return null;
                return (
                    <TableProvider
                        className={`${styles.tableProvider} table-provider`}
                        // downloadProps={nameToDownloadProps?.[name]?.downloadProps}
                        vis={_vis}
                        // display names if more than one providers are given
                        providerName={
                            names?.length > 1 ? name : undefined
                            // providerNames?.length > 1 ? name : undefined
                        }
                        // display link underneath the download button for single provider case
                        // openDataDownload={names?.length === 1 ? downloadLink : undefined}
                        openDataDownload={undefined}
                        key={nameIndex}
                    />
                );
            })}

            {footer != null && <Paragraph title={""} status={true} nid={0} text={footer} className="col-12" />}
        </div>
    );
};
